import { useEffect } from "react";
import { LanguageApi } from "../system/api/LanguageApi";
import { actions, store } from "../redux";
import { dispatch } from "../App";
import { localStorageHelper } from "../system/helper/localStorage";
import { LanguageContent } from "../system/types/api/languageApi";
import { localStorageConfig } from "../system/config/localStorage";


const useAppLoad = () => {

    const  getAvailableLanguages = async () =>  {
        const api = new LanguageApi();

        const avLangResponse = await api.getAvailableLanguages();

        if (typeof avLangResponse !== 'object') {
            return;
        }

        if (avLangResponse.code === 200) {
            const state = store.getState();
            const appConfig = {
                ...state.system.appConfig,
                availAbleLanguage: avLangResponse.data,
            };

            dispatch(actions.system.setAppConfig(appConfig));
        }
    };

    const loadTranslations = () => {

        const localStorage = new localStorageHelper();

        const state = store.getState();
        const newAppConfig = {
            ...state.system.appConfig,
        };

        const langIso = localStorage.getItem<string>(localStorageConfig.languageIso);
        if (langIso !== null && langIso !== '') {
            newAppConfig.language = langIso;
        }

        const data = localStorage.getItem<LanguageContent>(localStorageConfig.languageData);

        if (data !== null) {
            newAppConfig.translations = data;
        }

        dispatch(actions.system.setAppConfig(newAppConfig));
    };

    useEffect(() => {
        getAvailableLanguages();
        loadTranslations();
    }, []);

};

export { useAppLoad };